module.exports = __webpack_public_path__ + "img/left-arrow.49c22d81.svg";